import { createFileRoute, redirect } from "@tanstack/react-router";
import { DEFAULT_LANG } from "@/lib/i18n";

// Locale-prefixed routing per §3. The default for every new visitor is English.
// Locale detection may suggest a switch in v1.5, but never force.
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/$lang", params: { lang: DEFAULT_LANG } });
  },
});
